import { MousePointer2 } from "lucide-react";
import { motion } from "motion/react";
import { useState, useEffect } from "react";

interface CustomCursorProps {
  name?: string;
  color?: string;
}

export default function CustomCursor({
  name = "You",
  color = "#10B981", // green
}: CustomCursorProps) {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
      setIsVisible(true);
    };

    const handleMouseLeave = () => {
      setIsVisible(false);
    };

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseleave", handleMouseLeave);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseleave", handleMouseLeave);
    };
  }, []);

  if (!isVisible) return null;

  return (
    <motion.div
      className="pointer-events-none fixed z-50"
      style={{
        left: mousePosition.x,
        top: mousePosition.y,
      }}
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.2 }}
    >
      <div className="relative">
        {/* Cursor icon */}
        <MousePointer2
          className="h-5 w-5 drop-shadow-lg"
          style={{ color: color, fill: color }}
        />

        {/* Name label */}
        <div
          className="absolute top-0 left-6 rounded px-2 py-1 text-xs whitespace-nowrap text-white shadow-lg"
          style={{ backgroundColor: color }}
        >
          {name}
        </div>

        {/* Subtle glow effect */}
        <div
          className="absolute -inset-2 rounded-full opacity-40 blur-md"
          style={{ backgroundColor: color }}
        />
      </div>
    </motion.div>
  );
}
